import { formatBadgeCount } from "@vega-core/utils/formatBadgeCount";

type Props = {
  count: number;
  isCollapsed: boolean;
};

export function NotificationNavBadge({ count, isCollapsed }: Props) {
  if (count <= 0) return null;

  return (
    <span
      className={
        isCollapsed
          ? "absolute top-1 right-1 inline-flex items-center justify-center min-w-4.5 h-4.5 px-1 rounded-full bg-brand-default text-text/on-brand body-extra-small-semibold leading-none"
          : "ml-2 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-brand-default text-text/on-brand body-extra-small-semibold"
      }
      data-testid="coinvest-notifications-nav-count"
    >
      {formatBadgeCount(count)}
    </span>
  );
}
